module.exports = __webpack_public_path__ + "static/media/sdb.c655766b.jpg";